import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ allowedRules = null, children }) => {
  const { token, user } = useAuth();

  if (!token) {
    return <Navigate to="/login" />;
  }

  if (allowedRules && !allowedRules.includes(user.Kullanici_Yetki)) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute; 